export const labelStyle = {
  padding: '4px 8px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: '500',
  color: 'white',
  whiteSpace: 'nowrap',
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  textShadow: `
                -1.2px -1.2px 0 #000,
                 1.2px -1.2px 0 #000,
                -1.2px  1.2px 0 #000,
                 1.2px  1.2px 0 #000,
                 0px    1.2px 0 #000,
                 0px   -1.2px 0 #000,
                 1.2px  0px  0 #000,
                -1.2px  0px  0 #000
              `,
};